import { createNamespacedStorage } from "./namespaced-storage";
/**
 * localStorage persistence for DataTable column visibility.
 *
 * Keyed by the table's `tableId`, so each table remembers its own columns
 * independently across reloads and navigation (per-browser/per-device).
 *
 * The full `ColumnVisibilityState` map is stored — including explicit `true` values —
 * rather than the compact hidden-only list the URL uses. This is deliberate: a
 * column that is hidden by default and then toggled *visible* can only be
 * remembered if its explicit `true` survives, which a hidden-only list cannot
 * express.
 */ function validateVisibilityMap(stored) {
    if (typeof stored !== "object" || stored === null || Array.isArray(stored)) {
        return null;
    }
    // Keep only boolean entries: TanStack treats any truthy value as visible, so
    // a stale/corrupt entry like `{ col: "false" }` would otherwise render the
    // column visible. Filtering keeps the returned map honestly a ColumnVisibilityState.
    const visibility = {};
    for (const [columnId, value] of Object.entries(stored)){
        if (typeof value === "boolean") visibility[columnId] = value;
    }
    return visibility;
}
const columnVisibilityStorage = createNamespacedStorage("columns", validateVisibilityMap);
export const columnVisibilityStorageKey = columnVisibilityStorage.storageKey;
export const readPersistedColumnVisibility = columnVisibilityStorage.read;
export const writePersistedColumnVisibility = columnVisibilityStorage.write;

//# sourceMappingURL=column-visibility-storage.js.map